import React, { FC } from 'react';

import { ReactComponent as HeaderLogo } from 'assets/acadly-logo.svg';

interface HeaderProps {
  selector?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
}

const Header: FC<HeaderProps> = (props) => {
  return (
    <header className='app__header'>
      <div className='header'>
        <div className='header__logo'>
          <HeaderLogo className='header__logo--logo' />
          <h2 className='header__logo--title'>LMS Plugin</h2>
        </div>
        <div className={`header__details ${props.selector ? props.selector : ''}`}>
          <h2 className='header__details--title'>{props.title}</h2>
          {props.subtitle ? <p className='header__details--subtitle'>{props.subtitle}</p> : null}
        </div>
      </div>
    </header>
  );
};

export default Header;
